module.exports = __webpack_public_path__ + "static/media/biofarma_logo.609ae1d8.png";